module.exports = __webpack_public_path__ + "static/img/BD2.415ea34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BD2.png
// module id = n/nH
// module chunks = 1